import { Box } from '@chakra-ui/react';

interface MessageFooterProps {
  isMe?: boolean;
  children: React.ReactNode;
}

export function MessageFooter({ isMe = false, children }: MessageFooterProps) {
  return (
    <Box
      className="MessageFooter"
      gap="1"
      display="inline-flex"
      flexWrap="wrap"
      justifyContent={isMe ? 'flex-end' : 'flex-start'}
      mt="1"
    >
      {children}
    </Box>
  );
}
